import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames';
import { Dropdown, IconButton, Icon } from 'components';
import Form from './Form/Form';
import styles from './Builder.scss';

const Builder = ({ assistiveTextLabels, assistiveTextContent, onUpdateText, className }) => {
    return (
        <Dropdown
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            renderTrigger={({open, isOpen}) =>
                <IconButton
                    onClick={open}
                    className={classnames(styles.triggerIcon, className, { [styles.isOpen]: isOpen })}
                >
                    <Icon name='ion-md-create' size='small' />
                </IconButton>
            }
            renderContent={({ close }) =>
                <Form
                    assistiveTextContent={assistiveTextContent}
                    assistiveTextLabels={assistiveTextLabels}
                    onUpdateText={onUpdateText}
                    close={close}
                />
            }
        />
    )
}

Builder.propTypes = {
    assistiveTextLabels: PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.string
    }),
    assistiveTextContent: PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.string
    }),
    onUpdateText: PropTypes.func.isRequired,
    className: PropTypes.string
}

Builder.defaultProps = {
    assistiveTextLabels: {
        title: 'Title',
        description: 'Description',
        close: 'Close',
        save: 'Save'
    },
    assistiveTextContent: { title: '', description: '' },
    className: ''
};

export default Builder
